// import { values as _values } from 'lodash';
import StringHandler from './StringHandler';


const mergeBy = (a, b, condition) => {
	for (let i = 0; i < a.length; i++) {
		const row = b.find((item) => (item[condition] === a[i][condition]));

		if (row) {
			a[i][2] = row[1];
		}
	}

	return a;
};
const sortBy = (array, sortArray, key) => (
	[ ...array ].sort((a, b) => sortArray.indexOf(a[key]) - sortArray.indexOf(b[key]))
);
const sortByKeyword = (array, keyword, keys) => {
	const arrKey = typeof keys === 'string' ? [ keys ] : keys;
	const result = [ ...array ].sort((a, b) => {
		let comparison = 0;
		
		for (let i = 0; i < arrKey.length; i++) {
			const key = arrKey[i];
			const strKeyword = StringHandler.getString(keyword);
			const strA = StringHandler.getString(a[key]);
			const strB = StringHandler.getString(b[key]);
			const condition = (strA === strKeyword) || (strA.indexOf(strKeyword) === 0 
					&& strB.indexOf(strKeyword) === 0 && strB.length - strA.length > 0)
					|| (strA.indexOf(strKeyword) > 0 && strB.indexOf(strKeyword) > 0 
					&& strB.indexOf(strKeyword) - strA.indexOf(strKeyword) > 0);
			
			if (condition) { comparison = -1; }
		}
		
		return comparison;
	});
	
	return result;
}
const sorter = (data, key, isASC = true) => {
	const result = data.sort((a, b) => {
		let comparison = 0;

		if (a[key] === null) {
			comparison = (b[key] === null) ? 0 : -1;
		} else if (a[key] > b[key]) {
			comparison = isASC ? 1 : -1;
		} else if (a[key] < b[key]) {
			comparison = isASC ? -1 : 1;
		}

		return comparison;
	});

	return result;
};


export default { mergeBy, sortBy, sortByKeyword, sorter }
